import {
    RoomPermissionCommentSchema,
    RoomPermissionMembersSchema,
    RoomPermissionMessageSchema,
    RoomPermissionOtherSchema,
    RoomPermissionSchema,
    RoomPermissionSurveySchema,
    RoomPermissionTaskSchema,
} from '@/entities/portal/room/Room'
import { z } from '@/utils/zod'

export const RoomAccessPermissionsSchema = z.object({
    room: RoomPermissionSchema.nullable(),
    member: RoomPermissionMembersSchema.nullable(),
    message: RoomPermissionMessageSchema.nullable(),
    survey: RoomPermissionSurveySchema.nullable(),
    comment: RoomPermissionCommentSchema.nullable(),
    task: RoomPermissionTaskSchema.nullable(),
    other: RoomPermissionOtherSchema.nullable(),
})

export type RoomAccessPermissions = z.infer<typeof RoomAccessPermissionsSchema>

export const RoomAccessSchema = z.object({
    room: z.objectId(),
    addedAt: z.isoDateOnly,
    addedByTag: z.boolean(),
    permissions: RoomAccessPermissionsSchema.nullable(),
})

export type RoomAccess = z.infer<typeof RoomAccessSchema>
